// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compact-limit-modal {
  max-width: 380px;
}
.compact-limit-modal .limit-icon {
  font-size: 2rem;
  margin-bottom: 0.75rem;
}
.compact-limit-modal h3 {
  font-size: 1.25rem;
  margin-bottom: 0.75rem;
}
.compact-limit-modal .limit-message {
  font-size: 0.9rem;
  margin-bottom: 1rem;
}
.compact-limit-modal .limit-message-small {
  font-size: 0.85rem;
  margin-top: 0.75rem;
  margin-bottom: 1rem;
  opacity: 0.8;
}
.compact-limit-modal .limit-stats-compact {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: #f5f5f5;
  border-radius: 6px;
  font-size: 0.9rem;
}
.compact-limit-modal .limit-stats-compact .stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}
.compact-limit-modal .limit-stats-compact .stat-item .stat-label {
  font-size: 0.75rem;
  opacity: 0.7;
  text-transform: uppercase;
}
.compact-limit-modal .limit-stats-compact .stat-item .stat-value {
  font-weight: 600;
  font-size: 1.1rem;
}
.compact-limit-modal .limit-stats-compact .stat-divider {
  font-size: 1.25rem;
  opacity: 0.3;
  margin: 0 0.25rem;
}
.compact-limit-modal .limit-actions-compact {
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
}
.compact-limit-modal .limit-actions-compact .limit-btn {
  flex: 1 1;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
}
.compact-limit-modal .limit-actions-compact .limit-btn.secondary {
  background: #e0e0e0;
  color: #333;
}
.compact-limit-modal .limit-actions-compact .limit-btn.secondary:hover {
  background: #d0d0d0;
}
.compact-limit-modal .limit-actions-compact .limit-btn.primary {
  background: #1976d2;
  color: white;
}
.compact-limit-modal .limit-actions-compact .limit-btn.primary:hover {
  background: #1565c0;
}

.date-range-inputs {
  display: block !important;
  margin-top: 15px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  background-color: #f9f9f9;
}
.date-range-inputs .date-input-group {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.date-range-inputs .date-input-group:last-child {
  margin-bottom: 0;
}
.date-range-inputs .date-input-group label {
  min-width: 80px;
  font-weight: 500;
  color: #333;
}
.date-range-inputs .date-input-group input[type=date] {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  flex: 1 1;
}

.detailsection-dashboard-wrapper {
  padding: 10px;
}
.detailsection-dashboard-wrapper .invoice-export-modal {
  padding: 0px;
  text-align: left;
  min-width: 500px;
  max-width: 600px;
  background: #fff;
  border-radius: 12px;
}
.detailsection-dashboard-wrapper .invoice-export-modal h3 {
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 600;
  color: #333;
  text-align: center;
}
.detailsection-dashboard-wrapper .invoice-export-modal .export-subtext {
  margin: 0 0 25px 0;
  font-size: 14px;
  color: #666;
  line-height: 1.4;
  text-align: center;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 60vh;
  overflow-y: scroll;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  background: #f8f9fa;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-title {
  margin: 0 0 15px 0;
  font-size: 16px;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #dee2e6;
  padding-bottom: 8px;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options .filter-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options .filter-option:hover {
  background: #e9ecef;
  border-color: #ced4da;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options .filter-option input[type=radio] {
  margin: 0;
  width: 16px;
  height: 16px;
  accent-color: var(--primary-color);
  cursor: pointer;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options .filter-option .filter-label {
  font-size: 14px;
  color: #495057;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options .filter-option:has(input:checked) {
  background: #e7f3ff;
  border-color: var(--primary-color);
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options .filter-option:has(input:checked) .filter-label {
  color: var(--primary-color);
  font-weight: 600;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .month-dropdown-container {
  margin-top: 15px;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .month-dropdown-container .month-dropdown {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  background: #fff;
  font-size: 14px;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s ease;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .month-dropdown-container .month-dropdown:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .month-dropdown-container .month-dropdown:hover {
  border-color: #adb5bd;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .month-dropdown-container .month-dropdown option {
  padding: 8px;
  color: #495057;
}
.detailsection-dashboard-wrapper .invoice-export-modal .export-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 1px solid #dee2e6;
}
.detailsection-dashboard-wrapper .invoice-export-modal .export-actions .export-btn {
  padding: 8px 18px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid;
  min-width: 100px;
}
.detailsection-dashboard-wrapper .invoice-export-modal .export-actions .export-btn.cancel-btn {
  background: #fff;
  color: #6c757d;
  border-color: #6c757d;
}
.detailsection-dashboard-wrapper .invoice-export-modal .export-actions .export-btn.cancel-btn:hover {
  background: #6c757d;
  color: #fff;
}
.detailsection-dashboard-wrapper .invoice-export-modal .export-actions .export-btn.export-btn-primary {
  background: var(--primary-color);
  color: #fff;
  border-color: var(--primary-color);
}
.detailsection-dashboard-wrapper .invoice-export-modal .export-actions .export-btn.export-btn-primary:active {
  transform: translateY(1px);
}
@media (max-width: 768px) {
  .detailsection-dashboard-wrapper .invoice-export-modal {
    min-width: auto;
    width: 90vw;
    max-width: 500px;
    padding: 20px;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section {
    padding: 15px;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options {
    grid-template-columns: 1fr;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .month-dropdown-container .month-dropdown {
    font-size: 13px;
    padding: 8px 10px;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .export-actions {
    flex-direction: column;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .export-actions .export-btn {
    width: 100%;
    min-width: auto;
  }
}
@media (max-width: 480px) {
  .detailsection-dashboard-wrapper .invoice-export-modal {
    width: 95vw;
    padding: 15px;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal h3 {
    font-size: 20px;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .filter-sections {
    gap: 20px;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section {
    padding: 12px;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-title {
    font-size: 14px;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options .filter-option {
    padding: 6px 8px;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options .filter-option .filter-label {
    font-size: 13px;
  }
}
.detailsection-dashboard-wrapper .common-modal-content:has(.pdf-export-modal) {
  border-radius: 8px !important;
  background: transparent !important;
  box-shadow: none !important;
}
.detailsection-dashboard-wrapper .pdf-export-modal {
  background: white;
  border-radius: 8px;
  padding: 24px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  margin: -2rem;
  border-radius: 8px !important;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  text-align: center;
  color: #333;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-orientation {
  margin-top: 20px;
  padding: 20px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background-color: #f8f9fa;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-orientation .orientation-options {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-orientation .orientation-options .orientation-option-wrapper .orientation-option {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 0;
  margin-bottom: 8px;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-orientation .orientation-options .orientation-option-wrapper .orientation-option input[type=radio] {
  margin: 0;
  cursor: pointer;
  accent-color: var(--primary-color);
  width: 18px;
  height: 18px;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-orientation .orientation-options .orientation-option-wrapper .orientation-option span {
  font-size: 16px;
  color: #333;
  font-weight: 600;
  cursor: pointer;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-orientation .orientation-options .orientation-option-wrapper .orientation-option input[type=radio]:checked + span {
  color: var(--primary-color);
  font-weight: 700;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-orientation .orientation-options .orientation-option-wrapper .orientation-description {
  margin: 0 0 0 30px;
  font-size: 14px;
  color: #666;
  line-height: 1.4;
  font-weight: 400;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 25px;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-actions .btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-actions .btn-cancel:hover {
  background-color: #f8f9fa;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-actions .btn-export {
  padding: 8px 16px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-actions .btn-export:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-actions .btn-export:not(:disabled):hover {
  opacity: 0.9;
}
.detailsection-dashboard-wrapper .detailsection-dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  flex-wrap: wrap;
  gap: 10px;
}
.detailsection-dashboard-wrapper .detailsection-dashboard-header .new-case-btn {
  background-color: var(--primary-color);
  color: var(--text-color);
  border: none;
  padding: 8px 18px;
  border-radius: 0.5rem;
  cursor: pointer;
}
.detailsection-dashboard-wrapper .detailsection-dashboard-header .detailsection-search-input {
  flex: 1 1;
  max-width: 200px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
}
.detailsection-dashboard-wrapper .detailsection-dashboard-header .detailsection-search-input:focus {
  border-color: #ccc;
  outline: none;
}
.detailsection-dashboard-wrapper .detailsection-dashboard-header .detailsection-right-buttons {
  display: flex;
  gap: 10px;
}
.detailsection-dashboard-wrapper .detailsection-dashboard-header .detailsection-right-buttons .detailsection-export-btn,
.detailsection-dashboard-wrapper .detailsection-dashboard-header .detailsection-right-buttons .detailsection-import-btn {
  padding: 8px 18px;
  border: 1px solid #ccc;
  background-color: var(--primary-background-color);
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.detailsection-dashboard-wrapper .detailsection-dashboard-header .detailsection-right-buttons .detailsection-export-btn .detailsection-impexpicon,
.detailsection-dashboard-wrapper .detailsection-dashboard-header .detailsection-right-buttons .detailsection-import-btn .detailsection-impexpicon {
  width: 18px;
  height: 16px;
  margin-right: 10px;
}
.detailsection-dashboard-wrapper .detailsection-dashboard-cards {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}

.pdf-export-modal,
.invoice-export-modal {
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 768px) {
  .detailsection-dashboard-wrapper .detailsection-dashboard-cards {
    display: none;
  }
  .detailsection-dashboard-wrapper .pdf-export-modal,
  .detailsection-dashboard-wrapper .invoice-export-modal {
    min-width: auto;
    width: 90vw;
    max-width: 400px;
    padding: 20px;
  }
  .detailsection-dashboard-wrapper .pdf-export-modal .export-options,
  .detailsection-dashboard-wrapper .invoice-export-modal .export-options {
    flex-direction: column;
    gap: 12px;
  }
  .detailsection-dashboard-wrapper .pdf-export-modal .export-options .export-option-btn,
  .detailsection-dashboard-wrapper .invoice-export-modal .export-options .export-option-btn {
    min-width: auto;
    width: 100%;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .export-options {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 600px) {
  .detailsection-dashboard-wrapper .pdf-export-modal .export-options .export-option-btn,
  .detailsection-dashboard-wrapper .invoice-export-modal .export-options .export-option-btn {
    padding: 15px 20px;
    min-height: 50px;
  }
}
.user-limit-modal {
  text-align: center;
  min-width: 400px;
}
.user-limit-modal .limit-icon {
  font-size: 48px;
  margin-bottom: 20px;
  display: block;
}
.user-limit-modal h3 {
  margin: 0 0 16px 0;
  font-size: 24px;
  font-weight: 700;
  color: #e74c3c;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.user-limit-modal .limit-message {
  margin: 0 0 30px 0;
  font-size: 16px;
  color: #555;
  line-height: 1.5;
  font-weight: 400;
}
.user-limit-modal .limit-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 35px;
}
.user-limit-modal .limit-options .limit-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 10px;
  border: 1px solid #dee2e6;
  text-align: left;
  transition: all 0.3s ease;
}
.user-limit-modal .limit-options .limit-option.clickable {
  cursor: pointer;
}
.user-limit-modal .limit-options .limit-option.clickable:hover {
  background: linear-gradient(135deg, #dee2e6 0%, #ced4da 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}
.user-limit-modal .limit-options .limit-option.clickable:active {
  transform: translateY(0);
}
.user-limit-modal .limit-options .limit-option .option-icon {
  font-size: 20px;
  flex-shrink: 0;
}
.user-limit-modal .limit-options .limit-option span:not(.option-icon) {
  font-size: 15px;
  font-weight: 500;
  color: #333;
}
.user-limit-modal .limit-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 25px;
}
.user-limit-modal .limit-actions .limit-btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  min-width: 120px;
}
.user-limit-modal .limit-actions .limit-btn.secondary {
  background: #6c757d;
  color: white;
}
.user-limit-modal .limit-actions .limit-btn.secondary:hover {
  background: #5a6268;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}
.user-limit-modal .limit-actions .limit-btn.primary {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.user-limit-modal .limit-actions .limit-btn.primary:hover {
  background: linear-gradient(135deg, #0056b3 0%, #004494 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
}
.user-limit-modal .limit-actions .limit-btn.primary:active {
  transform: translateY(0);
}

.user-limit-modal {
  animation: limitModalSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes limitModalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-30px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.import-clients-modal {
  min-width: 500px;
  max-width: 600px;
  padding: 0;
}
.import-clients-modal .import-modal-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin: 0;
  padding: 20px 30px;
  border-bottom: 1px solid #e0e0e0;
}
.import-clients-modal .import-modal-content {
  padding: 30px;
}
.import-clients-modal .import-modal-content .upload-section {
  border: 2px dashed #d0d0d0;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  background: #fafafa;
  margin-bottom: 25px;
  transition: all 0.3s ease;
}
.import-clients-modal .import-modal-content .upload-section:hover {
  border-color: #1976d2;
  background: #f5f9ff;
}
.import-clients-modal .import-modal-content .upload-section .upload-icon-container {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
.import-clients-modal .import-modal-content .upload-section .upload-icon-container .upload-icon {
  color: #1976d2;
}
.import-clients-modal .import-modal-content .upload-section .upload-text {
  color: #666;
  font-size: 0.95rem;
  margin-bottom: 20px;
  line-height: 1.6;
}
.import-clients-modal .import-modal-content .upload-section .browse-btn {
  background: #1976d2;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s;
}
.import-clients-modal .import-modal-content .upload-section .browse-btn:hover {
  background: #1565c0;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(25, 118, 210, 0.3);
}
.import-clients-modal .import-modal-content .modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}
.import-clients-modal .import-modal-content .modal-actions .action-btn {
  padding: 10px 20px;
  border-radius: 6px;
  border: none;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}
.import-clients-modal .import-modal-content .modal-actions .action-btn svg {
  width: 18px;
  height: 18px;
}
.import-clients-modal .import-modal-content .modal-actions .action-btn.download-btn {
  background: transparent;
  color: #1976d2;
  border: 1px solid #1976d2;
  margin-right: auto;
}
.import-clients-modal .import-modal-content .modal-actions .action-btn.download-btn:hover {
  background: #e3f2fd;
}
.import-clients-modal .import-modal-content .modal-actions .action-btn.close-btn {
  background: #e0e0e0;
  color: #333;
}
.import-clients-modal .import-modal-content .modal-actions .action-btn.close-btn:hover {
  background: #d0d0d0;
}
.import-clients-modal .import-modal-content .modal-actions .action-btn.submit-btn {
  background: #1976d2;
  color: white;
}
.import-clients-modal .import-modal-content .modal-actions .action-btn.submit-btn:hover {
  background: #1565c0;
  box-shadow: 0 4px 8px rgba(25, 118, 210, 0.3);
}

@media (max-width: 768px) {
  .import-clients-modal {
    min-width: auto;
    width: 90vw;
  }
  .import-clients-modal .import-modal-content {
    padding: 20px;
  }
  .import-clients-modal .import-modal-content .upload-section {
    padding: 30px 20px;
  }
  .import-clients-modal .import-modal-content .modal-actions {
    flex-wrap: wrap;
  }
  .import-clients-modal .import-modal-content .modal-actions .action-btn.download-btn {
    width: 100%;
    margin-right: 0;
    justify-content: center;
  }
  .import-clients-modal .import-modal-content .modal-actions .action-btn.close-btn, .import-clients-modal .import-modal-content .modal-actions .action-btn.submit-btn {
    flex: 1 1;
  }
  .user-limit-modal {
    min-width: auto;
    width: 90vw;
    max-width: 400px;
    padding: 30px 20px;
  }
  .user-limit-modal .limit-actions {
    flex-direction: column;
  }
  .user-limit-modal .limit-actions .limit-btn {
    width: 100%;
    min-width: auto;
  }
  .user-limit-modal .limit-options .limit-option {
    padding: 12px 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/DetailSection/DetailSection.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AACE;EACE,eAAA;EACA,sBAAA;AACJ;AAEE;EACE,kBAAA;EACA,sBAAA;AAAJ;AAGE;EACE,iBAAA;EACA,mBAAA;AADJ;AAIE;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAHJ;AAKI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AAHN;AAKM;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;AAHR;AAMM;EACE,gBAAA;EACA,iBAAA;AAJR;AAQI;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;AANN;AAUE;EACE,aAAA;EACA,YAAA;EACA,gBAAA;AARJ;AAUI;EACE,SAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;AARN;AAUM;EACE,mBAAA;EACA,WAAA;AARR;AAUQ;EACE,mBAAA;AARV;AAYM;EACE,mBAAA;EACA,YAAA;AAVR;AAYQ;EACE,mBAAA;AAVV;;AAiBC;EACC,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAdF;AAgBE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAdJ;AAgBI;EACE,gBAAA;AAdN;AAiBI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAfN;AAkBI;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;AAhBN;;AAqBA;EACE,aAAA;AAlBF;AAoBA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAlBF;AAoBE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EAEA,YAAA;EACA,kBAAA;AArBJ;AAuBI;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AArBN;AAuBM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;AArBR;AAwBM;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAtBR;AA0BQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;AAxBV;AA0BU;EACE,mBAAA;EACA,qBAAA;AAxBZ;AA2BU;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,eAAA;AAzBZ;AA4BU;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AA1BZ;AA6BU;EACE,mBAAA;EACA,kCAAA;AA3BZ;AA6BY;EACE,2BAAA;EACA,gBAAA;AA3Bd;AAiCM;EACE,gBAAA;AA/BR;AAiCQ;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;AA/BV;AAiCU;EACE,aAAA;EACA,kCAAA;EACA,6CAAA;AA/BZ;AAkCU;EACE,qBAAA;AAhCZ;AAmCU;EACE,YAAA;EACA,cAAA;AAjCZ;AAwCE;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EAEA,iBAAA;EACA,6BAAA;AAvCJ;AAyCI;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AAvCN;AAyCM;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AAvCR;AAyCQ;EACE,mBAAA;EACA,WAAA;AAvCV;AA2CM;EACE,gCAAA;EACA,WAAA;EACA,kCAAA;AAzCR;AAgDQ;EACE,0BAAA;AA9CV;AAsDA;EACE;IACE,eAAA;IACA,WAAA;IACA,gBAAA;IACA,aAAA;EApDF;EAuDI;IACE,aAAA;EArDN;EAuDM;IACE,0BAAA;EArDR;EAwDM;IACE,eAAA;IACA,iBAAA;EAtDR;EA2DE;IACE,sBAAA;EAzDJ;EA2DI;IACE,WAAA;IACA,eAAA;EAzDN;AACF;AA8DA;EACE;IACE,WAAA;IACA,aAAA;EA5DF;EA8DE;IACE,eAAA;EA5DJ;EA+DE;IACE,SAAA;EA7DJ;EA+DI;IACE,aAAA;EA7DN;EA+DM;IACE,eAAA;EA7DR;EAgEM;IACE,gBAAA;EA9DR;EAgEQ;IACE,eAAA;EA9DV;AACF;AAsEA;EACE,6BAAA;EACA,kCAAA;EACA,2BAAA;AApEF;AAuEE;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,aAAA;EACA,6BAAA;AArEJ;AAuEI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AArEN;AAyEI;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAvEN;AAyEM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAvER;AA0EU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;AAxEZ;AA0EY;EACE,SAAA;EACA,eAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;AAxEd;AA2EY;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAzEd;AA4EY;EACE,2BAAA;EACA,gBAAA;AA1Ed;AA8EU;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AA5EZ;AAkFI;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AAhFN;AAkFM;EACE,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAhFR;AAkFQ;EACE,yBAAA;AAhFV;AAoFM;EACE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAlFR;AAoFQ;EACE,sBAAA;EACA,mBAAA;AAlFV;AAqFQ;EACE,YAAA;AAnFV;AAyFE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;AAvFJ;AAyFI;EACE,sCAAA;EACA,wBAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;AAvFN;AA0FI;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AAxFN;AA0FM;EACE,kBAAA;EACA,aAAA;AAxFR;AA4FI;EACE,aAAA;EACA,SAAA;AA1FN;AA4FM;;EAEE,iBAAA;EACA,sBAAA;EACA,iDAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA1FR;AA4FQ;;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAzFV;AA+FE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AA7FJ;;AAiGA;;EAEE,qCAAA;AA9FF;;AAiGA;EACE;IACE,UAAA;IACA,wCAAA;EA9FF;EAiGA;IACE,UAAA;IACA,iCAAA;EA/FF;AACF;AAkGA;EAEI;IACE,aAAA;EAjGJ;EAoGE;;IAEE,eAAA;IACA,WAAA;IACA,gBAAA;IACA,aAAA;EAlGJ;EAoGI;;IACE,sBAAA;IACA,SAAA;EAjGN;EAmGM;;IACE,eAAA;IACA,WAAA;EAhGR;EAqGE;IACE,0BAAA;EAnGJ;AACF;AAuGA;EAKQ;;IACE,kBAAA;IACA,gBAAA;EAxGR;AACF;AAgHA;EACE,kBAAA;EACA,gBAAA;AA9GF;AAgHE;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AA9GJ;AAiHE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yCAAA;AA/GJ;AAkHE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAhHJ;AAmHE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAjHJ;AAmHI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,6DAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;AAjHN;AAmHM;EACE,eAAA;AAjHR;AAmHQ;EACE,6DAAA;EACA,2BAAA;EACA,0CAAA;AAjHV;AAoHQ;EACE,wBAAA;AAlHV;AAsHM;EACE,eAAA;EACA,cAAA;AApHR;AAuHM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AArHR;AA0HE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;AAxHJ;AA0HI;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;AAxHN;AA0HM;EACE,mBAAA;EACA,YAAA;AAxHR;AA0HQ;EACE,mBAAA;EACA,2BAAA;EACA,+CAAA;AAxHV;AA4HM;EACE,6DAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AA1HR;AA4HQ;EACE,6DAAA;EACA,2BAAA;EACA,6CAAA;AA1HV;AA6HQ;EACE,wBAAA;AA3HV;;AAkIA;EACE,mEAAA;AA/HF;;AAkIA;EACE;IACE,UAAA;IACA,uCAAA;EA/HF;EAkIA;IACE,UAAA;IACA,iCAAA;EAhIF;AACF;AAoIA;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;AAlIF;AAoIE;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;AAlIJ;AAqIE;EACE,aAAA;AAnIJ;AAqII;EACE,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AAnIN;AAqIM;EACE,qBAAA;EACA,mBAAA;AAnIR;AAsIM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AApIR;AAsIQ;EACE,cAAA;AApIV;AAwIM;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAtIR;AAyIM;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AAvIR;AAyIQ;EACE,mBAAA;EACA,2BAAA;EACA,6CAAA;AAvIV;AA4II;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,iBAAA;EACA,6BAAA;AA1IN;AA4IM;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA1IR;AA4IQ;EACE,WAAA;EACA,YAAA;AA1IV;AA6IQ;EACE,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AA3IV;AA6IU;EACE,mBAAA;AA3IZ;AA+IQ;EACE,mBAAA;EACA,WAAA;AA7IV;AA+IU;EACE,mBAAA;AA7IZ;AAiJQ;EACE,mBAAA;EACA,YAAA;AA/IV;AAiJU;EACE,mBAAA;EACA,6CAAA;AA/IZ;;AAuJA;EACE;IACE,eAAA;IACA,WAAA;EApJF;EAsJE;IACE,aAAA;EApJJ;EAsJI;IACE,kBAAA;EApJN;EAuJI;IACE,eAAA;EArJN;EAwJQ;IACE,WAAA;IACA,eAAA;IACA,uBAAA;EAtJV;EAyJQ;IAEE,SAAA;EAxJV;EA+JA;IACE,eAAA;IACA,WAAA;IACA,gBAAA;IACA,kBAAA;EA7JF;EA+JE;IACE,sBAAA;EA7JJ;EA+JI;IACE,WAAA;IACA,eAAA;EA7JN;EAiKE;IACE,kBAAA;EA/JJ;AACF","sourcesContent":[".compact-limit-modal {\n  max-width: 380px;\n\n  .limit-icon {\n    font-size: 2rem;\n    margin-bottom: 0.75rem;\n  }\n\n  h3 {\n    font-size: 1.25rem;\n    margin-bottom: 0.75rem;\n  }\n\n  .limit-message {\n    font-size: 0.9rem;\n    margin-bottom: 1rem;\n  }\n\n  .limit-message-small {\n    font-size: 0.85rem;\n    margin-top: 0.75rem;\n    margin-bottom: 1rem;\n    opacity: 0.8;\n  }\n\n  .limit-stats-compact {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.75rem;\n    padding: 0.75rem;\n    background: #f5f5f5;\n    border-radius: 6px;\n    font-size: 0.9rem;\n\n    .stat-item {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 0.25rem;\n\n      .stat-label {\n        font-size: 0.75rem;\n        opacity: 0.7;\n        text-transform: uppercase;\n      }\n\n      .stat-value {\n        font-weight: 600;\n        font-size: 1.1rem;\n      }\n    }\n\n    .stat-divider {\n      font-size: 1.25rem;\n      opacity: 0.3;\n      margin: 0 0.25rem;\n    }\n  }\n\n  .limit-actions-compact {\n    display: flex;\n    gap: 0.75rem;\n    margin-top: 1rem;\n\n    .limit-btn {\n      flex: 1;\n      padding: 0.5rem 1rem;\n      font-size: 0.9rem;\n      border-radius: 6px;\n      border: none;\n      cursor: pointer;\n      transition: all 0.2s;\n\n      &.secondary {\n        background: #e0e0e0;\n        color: #333;\n\n        &:hover {\n          background: #d0d0d0;\n        }\n      }\n\n      &.primary {\n        background: #1976d2;\n        color: white;\n\n        &:hover {\n          background: #1565c0;\n        }\n      }\n    }\n  }\n} \n \n .date-range-inputs {\n  display: block !important;\n  margin-top: 15px;\n  padding: 15px;\n  border: 1px solid #e0e0e0;\n  border-radius: 5px;\n  background-color: #f9f9f9;\n\n  .date-input-group {\n    margin-bottom: 10px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    label {\n      min-width: 80px;\n      font-weight: 500;\n      color: #333;\n    }\n\n    input[type=\"date\"] {\n      padding: 8px 12px;\n      border: 1px solid #ccc;\n      border-radius: 4px;\n      font-size: 14px;\n      flex: 1;\n    }\n  }\n}\n\n.detailsection-dashboard-wrapper {\n  padding: 10px;\n\n.invoice-export-modal {\n  padding: 0px;\n  text-align: left;\n  min-width: 500px;\n  max-width: 600px;\n  background: #fff;\n  border-radius: 12px;\n\n  h3 {\n    margin: 0 0 8px 0;\n    font-size: 24px;\n    font-weight: 600;\n    color: #333;\n    text-align: center;\n  }\n\n  .export-subtext {\n    margin: 0 0 25px 0;\n    font-size: 14px;\n    color: #666;\n    line-height: 1.4;\n    text-align: center;\n  }\n\n  .filter-sections {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    // margin-bottom: 30px;\n    height: 60vh;\n    overflow-y: scroll;\n\n    .filter-section {\n      border: 1px solid #e9ecef;\n      border-radius: 8px;\n      padding: 20px;\n      background: #f8f9fa;\n\n      .filter-title {\n        margin: 0 0 15px 0;\n        font-size: 16px;\n        font-weight: 600;\n        color: #495057;\n        border-bottom: 2px solid #dee2e6;\n        padding-bottom: 8px;\n      }\n\n      .filter-options {\n        display: grid;\n        grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n        gap: 12px;\n\n\n\n        .filter-option {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          cursor: pointer;\n          padding: 8px 12px;\n          border-radius: 6px;\n          transition: all 0.2s ease;\n          border: 1px solid transparent;\n\n          &:hover {\n            background: #e9ecef;\n            border-color: #ced4da;\n          }\n\n          input[type=\"radio\"] {\n            margin: 0;\n            width: 16px;\n            height: 16px;\n            accent-color: var(--primary-color);\n            cursor: pointer;\n          }\n\n          .filter-label {\n            font-size: 14px;\n            color: #495057;\n            font-weight: 500;\n            cursor: pointer;\n            user-select: none;\n          }\n\n          &:has(input:checked) {\n            background: #e7f3ff;\n            border-color: var(--primary-color);\n            \n            .filter-label {\n              color: var(--primary-color);\n              font-weight: 600;\n            }\n          }\n        }\n      }\n\n      .month-dropdown-container {\n        margin-top: 15px;\n        \n        .month-dropdown {\n          width: 100%;\n          padding: 10px 12px;\n          border: 1px solid #ced4da;\n          border-radius: 6px;\n          background: #fff;\n          font-size: 14px;\n          color: #495057;\n          cursor: pointer;\n          transition: all 0.2s ease;\n          \n          &:focus {\n            outline: none;\n            border-color: var(--primary-color);\n            box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n          }\n          \n          &:hover {\n            border-color: #adb5bd;\n          }\n          \n          option {\n            padding: 8px;\n            color: #495057;\n          }\n        }\n      }\n    }\n  }\n\n  .export-actions {\n    display: flex;\n    gap: 12px;\n    justify-content: flex-end;\n    // margin-top: 25px;\n    padding-top: 20px;\n    border-top: 1px solid #dee2e6;\n\n    .export-btn {\n      padding: 8px 18px;\n      border-radius: 6px;\n      font-size: 14px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      border: 1px solid;\n      min-width: 100px;\n      \n      &.cancel-btn {\n        background: #fff;\n        color: #6c757d;\n        border-color: #6c757d;\n\n        &:hover {\n          background: #6c757d;\n          color: #fff;\n        }\n      }\n\n      &.export-btn-primary {\n        background: var(--primary-color);\n        color: #fff;\n        border-color: var(--primary-color);\n\n        // &:hover {\n        //   background: #0056b3;\n        //   border-color: #0056b3;\n        // }\n\n        &:active {\n          transform: translateY(1px);\n        }\n      }\n    }\n  }\n}\n\n// Responsive design\n@media (max-width: 768px) {\n  .invoice-export-modal {\n    min-width: auto;\n    width: 90vw;\n    max-width: 500px;\n    padding: 20px;\n\n    .filter-sections {\n      .filter-section {\n        padding: 15px;\n\n        .filter-options {\n          grid-template-columns: 1fr;\n        }\n        \n        .month-dropdown-container .month-dropdown {\n          font-size: 13px;\n          padding: 8px 10px;\n        }\n      }\n    }\n\n    .export-actions {\n      flex-direction: column;\n      \n      .export-btn {\n        width: 100%;\n        min-width: auto;\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .invoice-export-modal {\n    width: 95vw;\n    padding: 15px;\n    \n    h3 {\n      font-size: 20px;\n    }\n\n    .filter-sections {\n      gap: 20px;\n      \n      .filter-section {\n        padding: 12px;\n        \n        .filter-title {\n          font-size: 14px;\n        }\n        \n        .filter-options .filter-option {\n          padding: 6px 8px;\n          \n          .filter-label {\n            font-size: 13px;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Override CommonModal styling for PDF export modal\n.common-modal-content:has(.pdf-export-modal) {\n  border-radius: 8px !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n  .pdf-export-modal {\n    background: white;\n    border-radius: 8px;\n    padding: 24px;\n    width: 90%;\n    max-width: 800px;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n    margin: -2rem; // Counteract CommonModal's padding\n    border-radius: 8px !important; // Override CommonModal's border-radius\n\n    .export-modal-title {\n      font-size: 20px;\n      font-weight: 600;\n      margin-bottom: 16px;\n      text-align: center;\n      color: #333;\n    }\n\n    // Orientation Selection Styles\n    .export-modal-orientation {\n      margin-top: 20px;\n      padding: 20px;\n      border: 1px solid #e2e8f0;\n      border-radius: 8px;\n      background-color: #f8f9fa;\n\n      .orientation-options {\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n\n        .orientation-option-wrapper {\n          .orientation-option {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            cursor: pointer;\n            padding: 0;\n            margin-bottom: 8px;\n\n            input[type=\"radio\"] {\n              margin: 0;\n              cursor: pointer;\n              accent-color: var(--primary-color);\n              width: 18px;\n              height: 18px;\n            }\n\n            span {\n              font-size: 16px;\n              color: #333;\n              font-weight: 600;\n              cursor: pointer;\n            }\n\n            input[type=\"radio\"]:checked + span {\n              color: var(--primary-color);\n              font-weight: 700;\n            }\n          }\n\n          .orientation-description {\n            margin: 0 0 0 30px;\n            font-size: 14px;\n            color: #666;\n            line-height: 1.4;\n            font-weight: 400;\n          }\n        }\n      }\n    }\n\n    .export-modal-actions {\n      display: flex;\n      justify-content: flex-end;\n      gap: 12px;\n      margin-top: 25px;\n\n      .btn-cancel {\n        padding: 8px 16px;\n        border: 1px solid #ddd;\n        background: white;\n        color: #666;\n        border-radius: 4px;\n        cursor: pointer;\n        font-size: 14px;\n\n        &:hover {\n          background-color: #f8f9fa;\n        }\n      }\n\n      .btn-export {\n        padding: 8px 16px;\n        background: var(--primary-color);\n        color: white;\n        border: none;\n        border-radius: 4px;\n        cursor: pointer;\n        font-size: 14px;\n\n        &:disabled {\n          background-color: #ccc;\n          cursor: not-allowed;\n        }\n\n        &:not(:disabled):hover {\n          opacity: 0.9;\n        }\n      }\n    }\n  }\n\n  .detailsection-dashboard-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 5px;\n    flex-wrap: wrap;\n    gap: 10px;\n\n    .new-case-btn {\n      background-color: var(--primary-color);\n      color: var(--text-color);\n      border: none;\n      padding: 8px 18px;\n      border-radius: 0.5rem;\n      cursor: pointer;\n    }\n\n    .detailsection-search-input {\n      flex: 1;\n      max-width: 200px;\n      padding: 8px;\n      border: 1px solid #ccc;\n      border-radius: 6px;\n\n      &:focus {\n        border-color: #ccc;\n        outline: none;\n      }\n    }\n\n    .detailsection-right-buttons {\n      display: flex;\n      gap: 10px;\n\n      .detailsection-export-btn,\n      .detailsection-import-btn {\n        padding: 8px 18px;\n        border: 1px solid #ccc;\n        background-color: var(--primary-background-color);\n        border-radius: 6px;\n        cursor: pointer;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        .detailsection-impexpicon {\n          width: 18px;\n          height: 16px;\n          margin-right: 10px;\n        }\n      }\n    }\n  }\n\n  .detailsection-dashboard-cards {\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 10px;\n  }\n}\n\n.pdf-export-modal,\n.invoice-export-modal {\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (max-width: 768px) {\n  .detailsection-dashboard-wrapper {\n    .detailsection-dashboard-cards {\n      display: none;\n    }\n\n    .pdf-export-modal,\n    .invoice-export-modal {\n      min-width: auto;\n      width: 90vw;\n      max-width: 400px;\n      padding: 20px;\n\n      .export-options {\n        flex-direction: column;\n        gap: 12px;\n\n        .export-option-btn {\n          min-width: auto;\n          width: 100%;\n        }\n      }\n    }\n\n    .invoice-export-modal .export-options {\n      grid-template-columns: 1fr;\n    }\n  }\n}\n\n@media (max-width: 600px) {\n  .detailsection-dashboard-wrapper {\n    .pdf-export-modal,\n    .invoice-export-modal {\n      .export-options {\n        .export-option-btn {\n          padding: 15px 20px;\n          min-height: 50px;\n        }\n      }\n    }\n  }\n}\n\n// Add this to your DetailSection.scss file\n\n.user-limit-modal {\n  text-align: center;\n  min-width: 400px;\n\n  .limit-icon {\n    font-size: 48px;\n    margin-bottom: 20px;\n    display: block;\n  }\n\n  h3 {\n    margin: 0 0 16px 0;\n    font-size: 24px;\n    font-weight: 700;\n    color: #e74c3c;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  }\n\n  .limit-message {\n    margin: 0 0 30px 0;\n    font-size: 16px;\n    color: #555;\n    line-height: 1.5;\n    font-weight: 400;\n  }\n\n  .limit-options {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-bottom: 35px;\n\n    .limit-option {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      padding: 16px 20px;\n      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n      border-radius: 10px;\n      border: 1px solid #dee2e6;\n      text-align: left;\n      transition: all 0.3s ease;\n\n      &.clickable {\n        cursor: pointer;\n\n        &:hover {\n          background: linear-gradient(135deg, #dee2e6 0%, #ced4da 100%);\n          transform: translateY(-2px);\n          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);\n        }\n\n        &:active {\n          transform: translateY(0);\n        }\n      }\n\n      .option-icon {\n        font-size: 20px;\n        flex-shrink: 0;\n      }\n\n      span:not(.option-icon) {\n        font-size: 15px;\n        font-weight: 500;\n        color: #333;\n      }\n    }\n  }\n\n  .limit-actions {\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n    margin-top: 25px;\n\n    .limit-btn {\n      padding: 12px 24px;\n      border-radius: 8px;\n      font-size: 14px;\n      font-weight: 600;\n      text-decoration: none;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      border: none;\n      min-width: 120px;\n\n      &.secondary {\n        background: #6c757d;\n        color: white;\n\n        &:hover {\n          background: #5a6268;\n          transform: translateY(-1px);\n          box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);\n        }\n      }\n\n      &.primary {\n        background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);\n        color: white;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n\n        &:hover {\n          background: linear-gradient(135deg, #0056b3 0%, #004494 100%);\n          transform: translateY(-2px);\n          box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);\n        }\n\n        &:active {\n          transform: translateY(0);\n        }\n      }\n    }\n  }\n}\n\n.user-limit-modal {\n  animation: limitModalSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n@keyframes limitModalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-30px) scale(0.9);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n// Import Clients Modal Styles\n.import-clients-modal {\n  min-width: 500px;\n  max-width: 600px;\n  padding: 0;\n\n  .import-modal-title {\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: #333;\n    margin: 0;\n    padding: 20px 30px;\n    border-bottom: 1px solid #e0e0e0;\n  }\n\n  .import-modal-content {\n    padding: 30px;\n\n    .upload-section {\n      border: 2px dashed #d0d0d0;\n      border-radius: 8px;\n      padding: 40px;\n      text-align: center;\n      background: #fafafa;\n      margin-bottom: 25px;\n      transition: all 0.3s ease;\n\n      &:hover {\n        border-color: #1976d2;\n        background: #f5f9ff;\n      }\n\n      .upload-icon-container {\n        display: flex;\n        justify-content: center;\n        margin-bottom: 15px;\n\n        .upload-icon {\n          color: #1976d2;\n        }\n      }\n\n      .upload-text {\n        color: #666;\n        font-size: 0.95rem;\n        margin-bottom: 20px;\n        line-height: 1.6;\n      }\n\n      .browse-btn {\n        background: #1976d2;\n        color: white;\n        border: none;\n        padding: 10px 24px;\n        border-radius: 6px;\n        font-size: 0.95rem;\n        cursor: pointer;\n        transition: all 0.2s;\n\n        &:hover {\n          background: #1565c0;\n          transform: translateY(-1px);\n          box-shadow: 0 4px 8px rgba(25, 118, 210, 0.3);\n        }\n      }\n    }\n\n    .modal-actions {\n      display: flex;\n      gap: 12px;\n      justify-content: flex-end;\n      padding-top: 20px;\n      border-top: 1px solid #e0e0e0;\n\n      .action-btn {\n        padding: 10px 20px;\n        border-radius: 6px;\n        border: none;\n        font-size: 0.95rem;\n        cursor: pointer;\n        transition: all 0.2s;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n\n        svg {\n          width: 18px;\n          height: 18px;\n        }\n\n        &.download-btn {\n          background: transparent;\n          color: #1976d2;\n          border: 1px solid #1976d2;\n          margin-right: auto;\n\n          &:hover {\n            background: #e3f2fd;\n          }\n        }\n\n        &.close-btn {\n          background: #e0e0e0;\n          color: #333;\n\n          &:hover {\n            background: #d0d0d0;\n          }\n        }\n\n        &.submit-btn {\n          background: #1976d2;\n          color: white;\n\n          &:hover {\n            background: #1565c0;\n            box-shadow: 0 4px 8px rgba(25, 118, 210, 0.3);\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .import-clients-modal {\n    min-width: auto;\n    width: 90vw;\n\n    .import-modal-content {\n      padding: 20px;\n\n      .upload-section {\n        padding: 30px 20px;\n      }\n\n      .modal-actions {\n        flex-wrap: wrap;\n\n        .action-btn {\n          &.download-btn {\n            width: 100%;\n            margin-right: 0;\n            justify-content: center;\n          }\n\n          &.close-btn,\n          &.submit-btn {\n            flex: 1;\n          }\n        }\n      }\n    }\n  }\n\n  .user-limit-modal {\n    min-width: auto;\n    width: 90vw;\n    max-width: 400px;\n    padding: 30px 20px;\n\n    .limit-actions {\n      flex-direction: column;\n\n      .limit-btn {\n        width: 100%;\n        min-width: auto;\n      }\n    }\n\n    .limit-options .limit-option {\n      padding: 12px 16px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
